export default __webpack_public_path__ + "static/media/information.2c750a4c.png";